import type { StepDefinition } from "@/shared/components/common/PropertyStepperScreen";
import type { LocalSupportingDocumentItem } from "@/features/protest/services/localSupportingDocuments.service";
import stepStyles from "../SelectProperty/SelectPropertyTypePage.module.css";

export type SupportingDocumentsReviewSectionProps = {
  title?: string;
  steps: StepDefinition[];
  localSupportingDocuments: LocalSupportingDocumentItem[];
};

export const SupportingDocumentsReviewSection = ({
  title = "Review uploaded supporting documents",
  steps,
  localSupportingDocuments,
}: SupportingDocumentsReviewSectionProps) => {
  console.log("localSupportingDocuments", localSupportingDocuments);
  return (
    <div className={stepStyles.reviewUploads}>
      <div className={stepStyles.reviewUploadsTitle}>{title}</div>
      {steps
        .filter((step) => step.supportingDocumentType)
        .map((step) => {
          const files = localSupportingDocuments.filter(
            (doc) => doc.documentType === step.supportingDocumentType
          );
          return (
            <div key={step.id} className={stepStyles.reviewUploadsGroup}>
              <div className={stepStyles.reviewUploadsStepLabel}>{step.label}</div>
              {files.length === 0 ? (
                <div className={stepStyles.reviewUploadsEmpty}>No files uploaded.</div>
              ) : (
                <>
                  {files?.every((file) => file.fileName) && (
                    <>
                      <label className={stepStyles.reviewUploadsDescriptionLabel}>Files</label>
                      <ul className={stepStyles.reviewUploadsList}>
                        {files.map((file) => (
                          <li key={file.id}>{file.fileName}</li>
                        ))}
                      </ul>
                    </>
                  )}
                  <label className={stepStyles.reviewUploadsDescriptionLabel}>Description</label>
                  {/* <div style={{ fontSize: "11px" , marginLeft: "1px"}}>{files[0]?.description || ""}</div> */}
                  <ul className={stepStyles.reviewDescriptionList}>
                    <li>{files[0]?.description || ""}</li>
                  </ul>
                </>
              )}
            </div>
          );
        })}
    </div>
  );
};
